import Service from './Service';
import UserAccount from './UserAccount';
import Navigation from './Navigation';

class Messenger extends Service {
  view = 'button';
  updateView(view, userId, conversationId, collectionId, contentId) {
    if (this.view === view && this.userId === userId && this.conversationId === conversationId
      && this.collectionId === collectionId && this.contentId === contentId) return;
    if (userId === UserAccount.account._id) return;
    this.view = view;
    this.userId = userId;
    this.conversationId = conversationId;
    this.collectionId = collectionId;
    this.contentId = contentId;
    this.emitStateUpdate();
  }
  updateUnread(unread) {
    if (unread === this.unread) return;
    this.unread = unread;
    this.emitStateUpdate();
  }
}

const singleton = new Messenger();

function getConversationIdFromSearch() {
  const id = new URLSearchParams(window.location.search).get('conversation');
  return id && id.trim() ? id.trim() : null;
}

function stripConversationQueryFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('conversation')) return;
  params.delete('conversation');
  const qs = params.toString();
  const path = window.location.pathname;
  Navigation.replace(`${path}${qs ? `?${qs}` : ''}`);
}

function syncMessengerFromConversationQuery() {
  const conversationId = getConversationIdFromSearch();
  if (!conversationId) return;
  singleton.updateView('messenger', null, conversationId);
  stripConversationQueryFromUrl();
}

function onNavigationState(_nav, navigationType) {
  if (navigationType === 'POP' && singleton.view === 'fullscreen') {
    singleton.updateView('button');
  }
  syncMessengerFromConversationQuery();
}

Navigation.onStateUpdate(onNavigationState);

setTimeout(syncMessengerFromConversationQuery, 1000);

export default singleton;
